import { ENDPOINTS } from "@/constants/endpoints";

// Endpoints that skip user token injection in beforeRequest.
// IMPORTANT: Any endpoint also listed in ENDPOINTS_USE_GUEST_LOGIN will receive
// the guest token for ALL users (authenticated or not), because the public check
// prevents the user token from overwriting the guest token.
export const PUBLIC_ENDPOINTS = [
  ENDPOINTS.AUTH.LOGIN_EMAIL,
  ENDPOINTS.AUTH.LOGIN_EMAIL_VERIFY,
  ENDPOINTS.AUTH.LOGIN_GUEST,
  ENDPOINTS.AUTH.REGISTER_EMAIL,
  ENDPOINTS.AUTH.FORGOT_PASSWORD,
  ENDPOINTS.AUTH.RESET_PASSWORD,
  ENDPOINTS.USERS.SELLER.ASSIGN_PASSWORD,
  ENDPOINTS.ADDRESS.COUNTRIES,
  "address/city"
];

// Endpoints that receive the guest token in beforeRequest.
// Token priority rules (see beforeRequest hook):
//   - Guest-only (not in PUBLIC_ENDPOINTS): guest token is set first, then
//     OVERWRITTEN by the user token when the user is authenticated.
//   - Guest + Public (in both lists): guest token is set and NEVER overwritten
//     by the user token — applies to ALL users regardless of auth state.
export const ENDPOINTS_USE_GUEST_LOGIN = {
  exact: [
    ENDPOINTS.AUTH.SEND_OTP,
    ENDPOINTS.MEDIA.PRESIGNED_URL,
    "payment",
    "category",
    ENDPOINTS.GENERATOR.RANDOM_CODE
  ],
  patterns: ["address"]
};
